const errorCls = "_275e79c3bc";
const iconCls = "_275i18hs0me";
const textCls = "_275tp47szq";
const buttonCls = "_275b1x3b7d2";
const buttonTextCls = "_275b1e4edf4";
const loadingEllipsisCls = "_275l1omy5yd";

export { buttonCls, buttonTextCls, errorCls, iconCls, loadingEllipsisCls, textCls };
import "./styles.linaria.module.css";
//# sourceMappingURL=styles.js.map
